import React from 'react';
import { Heart, Users, HeartHandshake, Undo2, RefreshCw, RotateCcw, ArrowRight } from 'lucide-react';
import { services, contactInfo } from '../data/mock';

const iconMap = {
  Heart,
  Users,
  HeartHandshake,
  Undo2,
  RefreshCw,
  RotateCcw
};

const ServicesSection = () => {
  return (
    <section id="services" className="py-16 sm:py-28 bg-gradient-to-b from-black via-gray-950 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header - H2 optimisé SEO */}
        <div className="text-center mb-12 sm:mb-20">
          <span className="inline-block px-4 sm:px-5 py-2 bg-amber-500/10 border border-amber-500/30 rounded-full text-amber-500 text-xs sm:text-sm font-semibold tracking-wide mb-4 sm:mb-6">
            Spécialiste Retour Affectif
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-8 px-2">
            Services de <span className="text-amber-500">Retour Affectif</span> par le Grand Marabout
          </h2>
          <p className="text-gray-300 text-base sm:text-xl max-w-3xl mx-auto leading-relaxed px-2">
            Grand marabout africain reconnu, le spécialiste vous accompagne avec des rituels puissants pour récupérer votre ex et retrouver l'amour. Plus de 290 couples réunis.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <article
                key={service.id}
                className="group relative bg-gray-900/50 border border-amber-500/10 rounded-2xl sm:rounded-3xl p-6 sm:p-10 hover:border-amber-500/40 transition-all duration-500 hover:transform hover:-translate-y-2"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Icon */}
                <div className="w-14 h-14 sm:w-[72px] sm:h-[72px] bg-amber-500/10 rounded-xl sm:rounded-2xl flex items-center justify-center mb-5 sm:mb-8 group-hover:bg-amber-500/20 transition-colors duration-300">
                  {IconComponent && <IconComponent className="w-7 h-7 sm:w-9 sm:h-9 text-amber-500" />}
                </div>

                {/* Content - H3 pour SEO */}
                <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 sm:mb-5 group-hover:text-amber-500 transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-gray-300 text-sm sm:text-lg mb-5 sm:mb-8 leading-relaxed">
                  {service.description}
                </p>

                {/* CTA Link */}
                <a
                  href={contactInfo.whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-amber-500 font-semibold text-sm sm:text-lg hover:text-amber-400 transition-colors group/link"
                >
                  <span>Contactez le Marabout</span>
                  <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 ml-2 group-hover/link:translate-x-1 transition-transform" />
                </a>

                {/* Decorative Corner */}
                <div className="absolute top-0 right-0 w-16 sm:w-24 h-16 sm:h-24 bg-gradient-to-br from-amber-500/5 to-transparent rounded-tr-2xl sm:rounded-tr-3xl" />
              </article>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 sm:mt-20 text-center px-4">
          <p className="text-gray-300 text-base sm:text-lg mb-4 sm:mb-6">Votre situation est unique ? Le grand marabout analyse chaque cas personnellement.</p>
          <a
            href={contactInfo.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-6 sm:px-10 py-4 sm:py-5 bg-amber-500 text-black font-bold text-base sm:text-lg rounded-full hover:bg-amber-400 transition-all duration-300 hover:scale-105"
          >
            Parlez au marabout maintenant
            <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 ml-2 sm:ml-3" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
